export default __webpack_public_path__ + "static/media/sistem-manajemen-project.10d852f9.jpg";